import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, useEffect } from 'react';

import { KnmCollapse } from '../../../KnmPackage/MainModule/components/KnmCollapse';
import { Row } from '../../../UIPackage/FormModule/components/Row';
import { DatePickerField } from '../../../UIPackage/MainModule/components/DatePickerField';
import styles from './CommonGroupCondition.module.scss';
import { IGroupConditionForm } from '../interfaces/IGroupConditionForm';
import { PassportGroupPassportTypeEnum } from '../enums/PassportGroupPassportTypeEnum';
import { FieldBlock } from '../../../UIPackage/FormModule/components/FieldBlock';
import { SelectInputField } from '../../../UIPackage/MainModule/components/SelectInputField';
import { RootActions } from '../../../CorePackage/MainModule/types/RootActions';
import { catalogGet } from '../../../CorePackage/CatalogsModule/actions/catalogsActions';
import { CommonCatalogsNamesEnum } from '../../../CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { getErvkOrderSelectOptions } from '../../../CorePackage/CatalogsModule/selectors/catalogsSelectors';

interface IAssignmentGroupConditionProps {
  name: string;
  category: IGroupConditionForm['category'];
}

export const AssignmentGroupCondition = ({ name, category }: IAssignmentGroupConditionProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const isErknm = category === PassportGroupPassportTypeEnum.ERKNM;
  const isPm = category === PassportGroupPassportTypeEnum.PM;
  const isDecision = category === PassportGroupPassportTypeEnum.DECISION_PASSPORT;

  const ervkOrderSelectOption = useSelector(getErvkOrderSelectOptions);

  useEffect(() => {
    dispatch(catalogGet(CommonCatalogsNamesEnum.ERVK_ORDERS));
  }, [dispatch]);

  if (!isErknm && !isPm && !isDecision) {
    return null;
  }

  return (
    <KnmCollapse title="Сведения о поручении мероприятий">
      <>
        <Row title="Дата поручения о проведении мероприятий (интервал)" justify="start" align="baseline">
          <DatePickerField name={`${name}.assigmentStartDate`} />
          <span className={styles.DateFieldsSpace}>—</span>
          <DatePickerField name={`${name}.assigmentEndDate`} />
        </Row>
        <FieldBlock label="Номера поручений о проведении мероприятий" margin="bottom">
          <SelectInputField
            name={`${name}.assignmentNumbers`}
            options={ervkOrderSelectOption}
            isMulti
            isSearchable
            isClearable
          />
        </FieldBlock>
      </>
    </KnmCollapse>
  );
};
